export default __webpack_public_path__ + "static/media/logo2-vertical.e34eb5e3.svg";